import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

export const useURLData = (params = null, param = null) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const redirect = searchParams.get("redirect");
  const isRedirect = redirect === "true";
  
  let paramValue = null;
  if (param) {
    paramValue = searchParams.get(param);
  }

  let paramObj = null;
  if (params && params.length > 0) {
    paramObj = {};
    params.forEach((param) => {
      paramObj[param] = searchParams.get(param);
    });
  }

  const getRedirectURL = (withRedirect) => {
    // Use URLSearchParams to manipulate query parameters
    const searchParams = new URLSearchParams(location.search);
    if (withRedirect) {
      // Return full URL with query params (including redirect if present)
      return `${location.pathname}?${searchParams.toString()}`;
    } else {
      // Remove the 'redirect' query parameter
      searchParams.delete("redirect");

      // Check if there are any remaining query parameters
      const remainingParams = searchParams.toString();

      // Return the URL without the '?' if there are no query parameters left
      return remainingParams
        ? `${location.pathname}?${remainingParams}`
        : location.pathname;
    }
  };

  let redirectURL = null;
  if (isRedirect) {
    redirectURL = getRedirectURL(false);
  }

  return {
    redirectURL,
    isRedirect,
    paramValue,
    paramObj,
  };
};
